<template>
  <div>
  </div>
</template>

<script>

export default {
  name: "Course",
}
</script>